import { Directive, ElementRef, HostListener} from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { AppInsightsService } from 'src/app/services/appinsights.service';

@Directive({
    selector: 'input,button,textarea,a,div',
    standalone: true
})
export class TrackingDirective {
  env = environment;
  appInsights : ApplicationInsights;
  userId;
  isPwa: string;

  constructor(private readonly el: ElementRef, private readonly cookieService: CookieService,
    private readonly appInsightsService: AppInsightsService) {
    if (this.env.appInsights.isEnable) {

      if (this.cookieService.get('userId') != null && this.cookieService.get('userId') !== '') {
        this.userId = this.cookieService.get('userId');

      }
      this.appInsights = appInsightsService.appInsightsObj();
    }

  }

  @HostListener('blur', ['$event']) onBlur(event: any) {
    const initalValue = this.el.nativeElement;
    const field = initalValue.getAttribute('formControlName');
    const uniqueIdField = initalValue.getAttribute('id');

    if (initalValue.localName === 'input') {
      if (field === 'Password' || field === 'ConfirmPassword') {
        console.log(field + ' ' + uniqueIdField + ' ' + '*************');
        this.trackEvent(initalValue.localName, field,field, '*************', this.userId);
        this.trackEventWithId(initalValue.localName, uniqueIdField, uniqueIdField, this.userId);
      } else {
        console.log(field + ' ' + uniqueIdField + ' ' + initalValue.value);
        this.trackEvent(initalValue.localName, field,field, initalValue.value, this.userId);
        this.trackEventWithId(initalValue.localName, uniqueIdField, uniqueIdField, this.userId);
        if(field=='IdNumber')
        {
          localStorage.setItem('idNumberIs',initalValue.value);
        }
      }
    } else if (initalValue.localName === 'textarea') {
      console.log(initalValue.localName + ' ' + initalValue.value + ' ' + field + ' ' + uniqueIdField);
      this.trackEvent('input', field, initalValue.value,initalValue.id, this.userId);
      this.trackEventWithId('input', uniqueIdField, initalValue.id, this.userId);
    }
  }

  @HostListener('click', ['$event']) onClick(event: any) {

    const initalValue = this.el.nativeElement;

    if (initalValue.localName === 'button') {
      this.handleButtonClick(initalValue);
    }
    if (initalValue.localName === 'div') {
      this.handleDivClick(initalValue);
    }
    if (initalValue.localName === 'a') {
      this.handleAnchorClick(initalValue, event);
    }
  }

  private handleButtonClick(initalValue: any) {
    console.log(initalValue.localName + ' ' + initalValue.name + ' ' + initalValue.value + initalValue.id);
    if (initalValue.name.includes('AccountPage')) {
      this.trackEvent(initalValue.localName, initalValue.name, initalValue.id, 'Accounts Data', this.userId);
    } else if (initalValue.name.includes('NewClientAcquistion')) {
      this.trackURLParams(initalValue.localName,
        initalValue.name, initalValue.id,
        initalValue.attributes.utm_source.nodeValue,
        initalValue.attributes.utm_medium.nodeValue,
        initalValue.attributes.utm_campaign.nodeValue,
        initalValue.attributes.isExistingUser.nodeValue,
        initalValue.attributes.userId.nodeValue);
    } else if (initalValue.value.length > 0) {
      this.trackEvent(initalValue.localName, initalValue.name, initalValue.id, initalValue.value, this.userId);

    } else {
      this.trackEvent(initalValue.localName, initalValue.name, initalValue.id, initalValue.innerText, this.userId);
    }

    if (initalValue.name.includes('btnRegisterRegisterPage')) {
      if (initalValue.hasAttribute('category') && initalValue.hasAttribute('subcategory')) {
        this.trackURLParamsReg(initalValue.localName,
          initalValue.name, initalValue.id,
          initalValue.attributes.category.nodeValue,
          initalValue.attributes.subcategory.nodeValue)
      }
    }
  }

  private handleDivClick(initalValue: any) {
    if (initalValue.id === 'new-display-quoted-range' || initalValue.id === 'old-display-quoted-amount') {
      this.trackDivEventWithId(initalValue.localName, initalValue.name, initalValue.id, initalValue.href, this.userId)
    }
  }

  private handleAnchorClick(initalValue: any, event: any) {
    if (initalValue.name.includes('SolutionsForYouHomePage')) {
      this.trackAnchorEventWithName(initalValue.localName, initalValue.name, initalValue.id, initalValue.href, this.userId,
        initalValue.attributes.category.nodeValue, initalValue.attributes.subcategory.nodeValue)
    }

    this.trackIntermediaryAnchorEvents(initalValue, event);
    this.trackDefaultAnchorEvent(initalValue, event);
  }

  private trackIntermediaryAnchorEvents(initalValue: any, event: any) {
    if (initalValue.name.includes('trackIntermediaryCodeUserLogin')) {
      let documentPdfId = event.target.dataset.documentpdfId;
      let intermediaryUtm_Id = localStorage.getItem("intermediaryDataUtm_id");
      let intermediaryCode = localStorage.getItem("intermediaryDataCode");
      let userId = localStorage.getItem("userId");
      this.trackIntermediaryUserLogin(initalValue.localName, initalValue.name, initalValue.innerText, documentPdfId, userId, intermediaryUtm_Id, intermediaryCode);
    }
    if (initalValue.name.includes('trackIntermediaryPDFGenerate')) {
      let documentPdfId = event.target.dataset.documentpdfgenerateId;
      let pdfId = "SCS-PDF-Generate";
      let intermediaryUtm_Id = localStorage.getItem("intermediaryDataUtm_id");
      let intermediaryCode = localStorage.getItem("intermediaryDataCode");
      let userId = localStorage.getItem("userId");
      this.trackIntermediaryPDFGenerate(initalValue.localName, initalValue.name, documentPdfId, userId, pdfId, intermediaryUtm_Id, intermediaryCode);
    }

    if (initalValue.name.includes('trackIntermediaryAssociateLogin')) {
      let documentPdfId = event.target.dataset.documentpdfId;
      let intermediaryUtm_Id = localStorage.getItem("intermediaryDataUtm_id");
      let intermediaryCode = localStorage.getItem("intermediaryDataCode");
      let userId = localStorage.getItem("userId");

      this.trackIntermediaryAssociateLogin(initalValue.localName, initalValue.name, documentPdfId, userId, intermediaryUtm_Id, intermediaryCode);
    }
    if (initalValue.name.includes('trackIntermediaryUserAssociateRegister')) {
      let documentPdfId = event.target.dataset.documentpdfId;
      let intermediaryUtm_Id = localStorage.getItem("intermediaryDataUtm_id");
      let intermediaryCode = localStorage.getItem("intermediaryDataCode");
      let idNumber = localStorage.getItem("idNumberIs");
      localStorage.setItem('UserAssociateWithRegisterAlready', '1');
      this.trackIntermediaryUserAssociateRegister(initalValue.localName, initalValue.name, documentPdfId, idNumber, intermediaryUtm_Id, intermediaryCode);
    }

    if (initalValue.name.includes('trackUserLLB')) {
      let userLeaderBoardBannerId = event.target.dataset.userleaderboardbannerId;
      let intermediaryUtm_Id = localStorage.getItem("intermediaryUserId");
      let intermediaryCode = "corp"
      let userAssociateLLB = "Yes";
      let userId = localStorage.getItem("userId");
      this.trackUserLLB(initalValue.localName, initalValue.name, userLeaderBoardBannerId, userId, userAssociateLLB, intermediaryUtm_Id, intermediaryCode);
    }
  }

  private trackDefaultAnchorEvent(initalValue: any, event: any) {
    if (initalValue.attributes.category == null && initalValue.attributes.subcategory == null) {
      this.trackAnchorWithoutCategory(initalValue, event);
    }
    else if (initalValue.innerText == "Coming soon, Notify me") {
      this.trackEvent(initalValue.localName, "notifyMePopup", initalValue.id, initalValue.innerText, this.userId);
    } else if (event.target.dataset.name == null) {
      this.trackEventAnchor(initalValue.localName, initalValue.innerText, initalValue.id, initalValue.href, this.userId,
        initalValue.attributes.category.nodeValue, initalValue.attributes.subcategory.nodeValue);
    }
    else {
      this.trackEventAnchor(initalValue.localName, event.target.dataset.name, initalValue.id, initalValue.href, this.userId,
        initalValue.attributes.category.nodeValue, initalValue.attributes.subcategory.nodeValue);
    }
  }

  private trackAnchorWithoutCategory(initalValue: any, event: any) {
    if (initalValue.attributes.attrarticle != null && initalValue.attributes.attrarticle.value == "article") {
      this.trackArticleClick(initalValue.localName, initalValue.name, initalValue.innerText, this.userId, initalValue.id);
    }
    else if (event.target.dataset.bannerId == null) {
      this.trackEvent(initalValue.localName, initalValue.name, initalValue.id, initalValue.innerText, this.userId);
    }
    else {
      let bannerId = event.target.dataset.bannerId;
      let userId = event.target.dataset.userId;
      this.trackBannerClick(initalValue.localName, initalValue.name, initalValue.id, initalValue.innerText, userId, bannerId);
    }
  }
  trackArticleClick(elementType, elementName, elementValue, userId,articleId) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Field',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: articleId,
          Value: elementValue,
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }


  @HostListener('change', ['$event']) onChange(event: any) {
    const initalValue = this.el.nativeElement;
    if (initalValue.type === 'checkbox') {
      const field = initalValue.getAttribute('formControlName');
      const fieldValue = initalValue.checked;
      console.log(field);
      this.trackEvent('input', initalValue.getAttribute('formControlName'),initalValue.getAttribute('formControlName'),
        initalValue.checked, this.userId);
    }
  }
  
  trackEvent(elementType, elementName,elementId, elementValue, userId) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;

    if(userId === undefined){
      if (this.cookieService.get('userId') != null && this.cookieService.get('userId') !== '') {
        userId = this.cookieService.get('userId');
      }
    }

    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Field',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          Value: elementValue,
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }

  trackEventWithId(elementType, elementName,elementId, userId) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;

    if(userId === undefined){
      if (this.cookieService.get('userId') != null && this.cookieService.get('userId') !== '') {
        userId = this.cookieService.get('userId');
      }
    }

    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'UniqueIdField',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }

  trackEventAnchor(elementType, elementName,elementId, elementValue, userId, category, subcategory) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;

    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Field',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          Value: elementValue,
          Category: category,
          SubCategory: subcategory,
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }

  trackURLParams(elementType, elementName,elementId, source, medium, campaign, clientType,userId) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;

    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Button',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          Source: source,
          Medium: medium,
          ClientType: clientType,
          Campaign: campaign,
          UserId: userId,
          SubmissionId: this.cookieService.get('submissionId'),
          isPwa: this.isPwa
        }
      });

    }
  }

  trackURLParamsReg(elementType, elementName,elementId, category, subcategory) {
    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Button',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          Category: category,
          Subcategory: subcategory,
          SubmissionId: this.cookieService.get('submissionId')
        }
      });

    }
  }

  trackAnchorEventWithName(elementType, elementName,elementId, elementValue, userId, category, subcategory) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.cookieService.get('userId') != null && this.cookieService.get('userId') !== '') {
      this.userId = this.cookieService.get('userId');
    }
    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Field',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          Value: elementValue,
          Category: category,
          SubCategory: subcategory,
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: this.userId,
          isPwa: this.isPwa
        }
      });


    }
  }
  trackDivEventWithId(elementType, elementName,elementId, elementValue, userId) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    
    if (this.cookieService.get('userId') != null && this.cookieService.get('userId') !== '') {
      this.userId = this.cookieService.get('userId');
    }
    if (this.env.appInsights.isEnable) {
   
      this.appInsights.trackEvent({
        name: elementType + 'Field',
        properties: {
          Type: elementType,
          Name: '',
          Id: elementId,
          Value: '',
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: this.userId,
          isPwa: this.isPwa
        }
      });


    }
  }

  trackBannerClick(elementType, elementName,elementId, elementValue, userId,bannerId) {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
      this.appInsights.trackEvent({
        name: elementType + 'Field',
        properties: {
          Type: elementType,
          Name: elementName,
          Id: elementId,
          BannerId: bannerId,
          Value: elementValue,
          SubmissionId: this.cookieService.get('submissionId'),
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }

  trackIntermediaryUserLogin(elementType, elementName, elementValue,documentPdfId, userId,intermediaryUtm_Id,intermediaryCode)
  {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
        this.appInsights.trackEvent({
        name:  elementType + 'IntermediaryLogin',
        properties: {
          Type: elementType,
          Name: elementName,
          Value: elementValue,
          IntermediaryUtm_Id: intermediaryUtm_Id,
          IntermediaryCode: intermediaryCode,
          SubmissionId: this.cookieService.get('submissionId'),
          DocumentPdfId:documentPdfId,
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }
  trackIntermediaryPDFGenerate(elementType, elementName,documentPdfGenerateId, userId,pdfId, intermediaryUtm_Id,intermediaryCode)
  {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
        this.appInsights.trackEvent({
        name:  elementType + 'IntermediaryPDFGenerate',
        properties: {
          Type: elementType,
          Name: elementName,
          PdfId : pdfId,
          IntermediaryUtm_Id: intermediaryUtm_Id,
          IntermediaryCode: intermediaryCode,
          SubmissionId: this.cookieService.get('submissionId'),
          DocumentPdfId:documentPdfGenerateId,
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }
  trackIntermediaryAssociateLogin(elementType, elementName,documentPdfAssociateId, userId,intermediaryUtm_Id,intermediaryCode)
  {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
        this.appInsights.trackEvent({
        name:  elementType + 'IntermediaryUserAssociateLogin',
        properties: {
          Type: elementType,
          Name: elementName,
          IntermediaryUtm_Id: intermediaryUtm_Id,
          IntermediaryCode: intermediaryCode,
          SubmissionId: this.cookieService.get('submissionId'),
          DocumentPdfId:documentPdfAssociateId,
          UserId: userId,
          isPwa: this.isPwa
        }
      });


    }
  }
  trackIntermediaryUserAssociateRegister(elementType, elementName,documentPdfAssociateId, idNumber,intermediaryUtm_Id,intermediaryCode)
  {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
        this.appInsights.trackEvent({
        name:  elementType + 'IntermediaryUserAssociateRegister',
        properties: {
          Type: elementType,
          Name: elementName,
          IntermediaryUtm_Id: intermediaryUtm_Id,
          IntermediaryCode: intermediaryCode,
          SubmissionId: this.cookieService.get('submissionId'),
          DocumentPdfId:documentPdfAssociateId,
          IdNumber: localStorage.getItem('idNumberIs'),
          isPwa: this.isPwa
        }
      });


    }
  }
  trackUserLLB(elementType, elementName,userLeaderBoardBannerId, userId,userAssociateLLB,intermediaryUtm_Id,intermediaryCode)
  {
    let isPwa = this.cookieService.get('isPwaActive');
    this.isPwa = isPwa;
    if (this.env.appInsights.isEnable) {
        this.appInsights.trackEvent({
        name:  elementType + 'IntermediaryUserLLB',
        properties: {
          Type: elementType,
          Name: elementName,
          IntermediaryUtm_Id: intermediaryUtm_Id,
          IntermediaryCode: intermediaryCode,
          SubmissionId: this.cookieService.get('submissionId'),
          DocumentPdfId:userLeaderBoardBannerId,
          UserId: userId,
          userAssociateLLB:userAssociateLLB,
          isPwa: this.isPwa
        }
      });


    }
  }
}